import { render, staticRenderFns } from "./AppBreadCrumb.vue?vue&type=template&id=5ba16dcb&scoped=true&"
import script from "./AppBreadCrumb.vue?vue&type=script&lang=js&"
export * from "./AppBreadCrumb.vue?vue&type=script&lang=js&"
import style0 from "./AppBreadCrumb.vue?vue&type=style&index=0&id=5ba16dcb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba16dcb",
  null
  
)

export default component.exports